import km, { Options as KmOptions } from '@ott/utility-km';

type ResolvedValue = string | number | boolean | null | undefined;

type TrackKm = (eventName: string, eventParams?: object) => void;

type CreateTrackKm = (
  context: string,
  commonParams?: Record<string, () => ResolvedValue>,
  options?: KmOptions
) => TrackKm;

// d

const createKm: CreateTrackKm = (context = '', commonParamsResolvers = {}, options) => {
  return (eventName, eventParams) => {
    const commonResolvedParams = Object.entries(commonParamsResolvers).reduce<
      Record<string, ResolvedValue>
    >((acc, [param, resolver]) => {
      acc[param] = resolver();

      return acc;
    }, {});

    const params = {
      ...commonResolvedParams,
      ...eventParams,
    };

    if (__PROD__) {
      km(eventName, { obj: params, ...options });
    } else {
      console.log(
        `%c KM${context ? `: ${context}` : ''} `,
        'background: #0050b3; color: #fff',
        eventName,
        params
      );
    }
  };
};

export default createKm;
